import React from 'react';
import { Link } from 'react-router-dom';

const DocumentationPage = () => (
  <div style={{ backgroundColor: '#0a0a0a', color: 'white', minHeight: '100vh', padding: '4rem 2rem' }}>
    <nav style={{ marginBottom: '4rem', textAlign: 'center' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
        <span style={{ fontSize: '1.5rem' }}>🧠</span>
        <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#e07a5f' }}>WhyDidItDie</span>
      </Link>
    </nav>

    <div style={{ maxWidth: '850px', margin: '0 auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#e07a5f' }}>Documentation</h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
        Everything you need to understand, integrate, and scale with WhyDidItDie. Our documentation is designed for
        marketers, analysts, and teams that want to dig deeper into their data and decision history.
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '2rem',
        marginBottom: '3rem'
      }}>
        <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ color: '#e07a5f' }}>🧩 Getting Started</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>
            Connect your ad platforms, sync campaign data, and begin your first forensic scan.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ color: '#e07a5f' }}>📉 Interpreting Reports</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>
            Learn how to decode failure points, timeline shifts, AI impact scores, and campaign recommendations.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ color: '#e07a5f' }}>🛡️ Decision Tracking</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>
            See how to log internal decisions, assign context, and map them to outcomes for true marketing accountability.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ color: '#e07a5f' }}>💳 Payments & Billing</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>
            View instructions for Paystack setup, subscription plans, and secure payment handling.
          </p>
        </div>
      </div>

      <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.7)', marginBottom: '2rem' }}>
        Our documentation will continue to grow. For now, check back regularly for new updates or contact us with questions.
      </p>

      <div style={{ textAlign: 'center' }}>
        <Link to="/homepage" style={{ color: '#e07a5f', textDecoration: 'none', fontSize: '1.1rem' }}>← Back to Home</Link>
      </div>
    </div>
  </div>
);

export default DocumentationPage;
